import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { compose } from 'recompose'
import TileGridV2 from '../TileGrid.v2/index'
import { H2, HEADING_TYPES } from '../Heading/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import Button, { TYPES } from '../Button/index'
import { connect as connectStaticText } from '../StaticText/connect'

const GridWithBackground = ({
  title,
  description,
  gridData,
  seeAllUrl,
  staticText,
}) => {
  return (
    <div className="grid-with-background">
      {
        gridData.first(null)
        && <React.Fragment>
          <div className="grid-with-background__header">
            <div className="grid-with-background__header__top-container">
              {title && <H2 as={[HEADING_TYPES.H1_MOBILE, HEADING_TYPES.H2_DESKTOP]} >{title}</H2>}

              {
                seeAllUrl
                && <div className="grid-with-background__header__top-container__button">
                  <Button
                    url={seeAllUrl}
                    className="account-pause-confirm__cta"
                    type={TYPES.GHOST}
                  >
                    {staticText.getIn(['data', 'seeAllButtonText'])}
                    <IconV2
                      className="account-pause-confirm__icon"
                      type={ICON_TYPES.CHEVRON_RIGHT}
                    />
                  </Button>
                </div>
              }
            </div>
            {description && <p className="grid-with-background__header__description">{description}</p>}
          </div>
          {
            <TileGridV2
              tileData={gridData}
              adminTitle={'Gaia+ Page - Watch First Episode for Free'}
            />
          }
        </React.Fragment>
      }
    </div>
  )
}

GridWithBackground.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  gridData: ImmutablePropTypes.list.isRequired,
  location: PropTypes.object.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  seeAllUrl: PropTypes.string,
}

export default compose(
  connectStaticText({ storeKey: 'gridWithBackground' }),
)(GridWithBackground)
